import React, { useMemo } from 'react';
import { Panel } from 'rsuite';
import { CustomHTML } from './CustomHTML';

interface Requirement {
  title?: string;
  text: string;
}

interface RequirementsListProps {
  requirements?: Requirement[] | null;
}

const RequirementsList = ({ requirements }: RequirementsListProps) => {
  const isSingle = useMemo(
    () => (requirements?.length ?? 0) === 1,
    [requirements]
  );

  const items = useMemo(
    () =>
      (requirements ?? []).map((requirement, index) => {
        const panel = (
          <Panel
            className={`mb-4 ${index === 0 ? '' : 'mt-24'}`}
            bodyFill
            style={{ fontWeight: 'normal' }}
          >
            {requirement.title && (
              <div style={{ marginBottom: '0.5rem', fontWeight: 'bold' }}>
                <CustomHTML text={requirement.title} />
              </div>
            )}
            <CustomHTML text={requirement.text} />
          </Panel>
        );

        return isSingle ? (
          <div key={`content_section_${index}`}>{panel}</div>
        ) : (
          <li key={`content_section_${index}`}>{panel}</li>
        );
      }),
    [isSingle, requirements]
  );

  if (!requirements?.length) return null;

  if (isSingle) return <div>{items}</div>;

  return (
    <ol
      style={{
        listStylePosition: 'outside',
        paddingLeft: '1.5rem',
        fontWeight: 'bold',
      }}
    >
      {items}
    </ol>
  );
};

export default RequirementsList;
